import { render } from "./MensagemItem.vue?vue&type=template&id=2418a028&scoped=true"
import script from "./MensagemItem.vue?vue&type=script&lang=js"
export * from "./MensagemItem.vue?vue&type=script&lang=js"

import "./MensagemItem.vue?vue&type=style&index=0&id=2418a028&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2418a028"]])

export default __exports__